<template>
  <el-row>
    <el-row class="movie-list">
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>邮件通知</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onAddEmail">添加</el-button>
          </div>
          <div class="text item">
            <el-table
              :data="emailAccountList"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="id"
                label="ID"
              />
              <el-table-column
                prop="smtp"
                label="SMTP"
              />
              <el-table-column
                prop="username"
                label="帐号"
              />
              <el-table-column
                prop="password"
                label="密码"
              />
              <el-table-column
                prop="personal"
                label="发送人"
              />
              <el-table-column
                fixed="right"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="onApprove(scope.row)"
                  >同意</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="onDecline(scope.row)"
                  >拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>webhook 通知</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onAddEmail">添加</el-button>
          </div>
          <div class="text item">
            <el-table
              :data="webhookList"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="id"
                label="ID"
              />
              <el-table-column
                prop="name"
                label="名字"
              />
              <el-table-column
                prop="webhook"
                label="Webhook"
              />
              <el-table-column
                prop="sign"
                label="签名"
              />
              <el-table-column
                fixed="right"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="onApprove(scope.row)"
                  >同意</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="onDecline(scope.row)"
                  >拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="movie-list">
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>通知配置</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onAddEmail">添加</el-button>
          </div>
          <div class="text item">
            <el-form ref="form" :model="notifyConfig" label-width="120px">
              <el-form-item label="邮件通知">
                <el-input v-model="notifyConfig.email" style="width: 70%; padding-right: 10px" readonly />
                <el-button size="mini" type="info" @click="showUpdateDialog(1)">更新</el-button>
              </el-form-item>
              <el-form-item label="webhook 通知">
                <el-input v-model="notifyConfig.webhook" style="width: 70%; padding-right: 10px" readonly />
                <el-button size="mini" type="info" @click="showUpdateDialog(1)">更新</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>注册管理</span>
          </div>
          <div class="text item">
            <el-form ref="form" :model="accountRegistry" label-width="100px">
              <el-form-item label="开放注册">
                <el-input v-model="accountRegistry.enabled" style="width: 50%; padding-right: 10px" readonly />
                <el-button size="mini" type="info" @click="onSetRegistry()">
                  <span v-if="!accountRegistry.enabled">启用</span>
                  <span v-else>禁用</span>
                </el-button>
              </el-form-item>
              <el-form-item label="图形验证码">
                <el-input v-model="accountRegistry.captchaCode" style="width: 50%; padding-right: 10px" readonly />
              </el-form-item>
              <el-form-item label="短信验证码">
                <el-input v-model="accountRegistry.verifyCode" style="width: 50%; padding-right: 10px" readonly />
              </el-form-item>
              <el-form-item label="启用验证码">
                <el-input v-model="accountRegistry.enableCode" style="width: 50%; padding-right: 10px" readonly />
                <el-button size="mini" type="info" @click="onSetCode()">
                  <span v-if="!accountRegistry.enableCode">启用</span>
                  <span v-else>禁用</span>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :visible.sync="updateDialog"
      width="30%"
      center
    >
      <el-row style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px; text-align: center">
        <el-form ref="form" :model="updateMobileForm" label-width="100px">
          <el-form-item label="密码">
            <el-input
              v-model="updateMobileForm.credential"
              type="password"
              placeholder="请输入密码"
              style="padding-right: 1px"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click.native="updateUserEmail"
            >更新</el-button>
            <el-button
              type="primary"
              @click.native="updateDialog = false"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { getNotifyConfig } from '@/api/admin'

export default {
  name: 'AdminNotifyConfig',
  mixins: [userMixin],
  data() {
    return {
      emailAccountList: [],
      webhookList: [],
      updateDialog: false,
      updateMobileForm: {
        principal: null,
        verifyCode: null,
        credential: null,
        captchaCode: null,
        channel: 1,
        plat: 2
      },
      notifyConfig: {
        email: '163mail',
        webhook: 'dingWebhook'
      },
      accountRegistry: null
    }
  },
  created() {
    document.title = '站点配置'
    this.getData()
  },
  methods: {
    getData() {
      this.getAccountRegistryWrapper()

      getNotifyConfig().then(resp => {
        if (resp.code === 0) {
          this.emailAccountList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // ****************************************************************************************************************
    onAddEmail() {
      this.updateDialog = false
    },
    updateUserEmail() {
      this.$message.info(this.updateMobileForm)
      this.updateDialog = false
    },
    onApprove(row) {
      this.$message.info('同意充值 ' + row.chargeId)
    },
    onDecline(row) {
      this.$message.info('拒绝充值' + row.chargeId)
    },
    showUpdateDialog() {
      this.$message.info('update notify')
    },
    getAccountRegistryWrapper() {
    },
    onSetRegistry() {
    },
    onSetCode() {
    }
  }
}
</script>

<style>
</style>
